import { apiGet } from '../../markets/api/apiClient';
import type { PiprBundle } from '../pipr/types';
import { fromWire, type WirePiprChart } from './piprWire';

export const CHART_PATH = '/api/monitor/pipr/chart';
const CACHE_TTL_MS = 30_000;
const CACHE_MAX = 32;

export interface ChartRequest {
    bank: string;
    from: Date;
    to: Date;
    resolution: number;
}

export function chartUrl(req: ChartRequest): string {
    const params = new URLSearchParams({
        bank: req.bank,
        from: req.from.toISOString(),
        to: req.to.toISOString(),
        resolution: String(req.resolution),
    });
    return `${CHART_PATH}?${params.toString()}`;
}

const cache = new Map<string, { at: number; value: Promise<PiprBundle> }>();

export function clearChartCache(): void {
    cache.clear();
}

export function loadPiprChart(req: ChartRequest): Promise<PiprBundle> {
    const url = chartUrl(req);
    const now = Date.now();
    const hit = cache.get(url);
    if (hit && now - hit.at < CACHE_TTL_MS) return hit.value;

    const value = apiGet<WirePiprChart>(url).then(fromWire);
    cache.set(url, { at: now, value });
    value.catch(() => {
        if (cache.get(url)?.value === value) cache.delete(url);
    });
    if (cache.size > CACHE_MAX) {
        const oldest = cache.keys().next().value;
        if (oldest !== undefined) cache.delete(oldest);
    }
    return value;
}
